export const PERMISSION_LEVELS = [
  { value: 'root', label: 'Root', description: 'Full system access. Bootstrap account.' },
  { value: 'org_admin', label: 'System Administrator', description: 'Full access to all features and settings.' },
  { value: 'administrator', label: 'Administrator', description: 'Can manage people, roles, and all content.' },
  { value: 'editor', label: 'Song Editor', description: 'Can manage the song library (add, edit, sync). Can view services and people but cannot manage them.' },
  { value: 'scheduler', label: 'Scheduler', description: 'Can create and manage services, assign team members. Can view songs and people but cannot manage them.' },
  { value: 'viewer', label: 'Viewer', description: 'Can view all services, songs, and people. Cannot make any changes.' },
  { value: 'scheduled_viewer', label: 'Scheduled Viewer', description: 'Can only view services they are assigned to. Can also view songs and people.' },
];

export const canAdmin = (user) =>
  user && ['root', 'org_admin', 'administrator'].includes(user.permission_level);

export const canEdit = (user) =>
  user && ['root', 'org_admin', 'administrator', 'editor'].includes(user.permission_level);

const SERVICE_LEADER_ROLES = ['Worship Leader', 'Program Director', 'Music Director', 'Tech Director'];

export const canEditService = (user, service) => {
  if (!user) return false;
  if (canSchedule(user)) return true;
  // A member assigned to a service in a leader role can also edit it
  const memberId = user.member_id;
  if (!memberId) return false;
  return (service?.team_assignments || []).some(t =>
    (t.assignments || []).some(a =>
      a.member_id === memberId && SERVICE_LEADER_ROLES.includes(a.role)
    )
  );
};

export const canSchedule = (user) =>
  user && ['root', 'org_admin', 'administrator', 'scheduler'].includes(user.permission_level);

export const isAdmin = (user) => canAdmin(user);

export const getPermissionLabel = (level) =>
  PERMISSION_LEVELS.find((p) => p.value === level)?.label || level;
